import { PROJECT_ID_SESSION_KEY } from "..";

export function getSelectedProjectIdFromSesssion(): string {
  const sessionProjectId = sessionStorage.getItem(PROJECT_ID_SESSION_KEY);
  return sessionProjectId ? sessionProjectId : undefined;
}
